import React, { RefObject } from "react";
import { find, map } from "lodash";
import moment from "moment/moment";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/pro-regular-svg-icons";
import {
  TimeTag,
  AppointmentItemArgs,
} from "components/appointments/appointmentsList/AppointmentItem";
import {
  faDesktopCircleArrowRight,
  faLocationDotArrow,
} from "../../../../icons/customIcons";

export default function MobileAppointmentItem({
  appointment,
  date,
  calendars,
  todayRef,
}: AppointmentItemArgs & { todayRef: RefObject<HTMLDivElement> }) {
  let markers = map(appointment.calendar_ids, (calendar_id: string) => {
    const calendar = find(calendars, (calendar) => calendar.id === calendar_id);
    return calendar?.color;
  });

  if (appointment.unknown_calendars) {
    markers = markers.concat(map(appointment.unknown_calendars, "color"));
  }

  return (
    <div
      className="grid gap-2 grid-cols-[1fr,2fr] pt-2 first:pt-0 px-6"
      ref={
        moment().isSame(moment(appointment.date.start), "day") ? todayRef : null
      }
    >
      <div className="flex flex-row justify-center items-center">
        <TimeTag date={date} appointment={appointment} />
      </div>
      <div className="name flex flex-row items-center">
        {map(markers, (color, index) => {
          if (!color) return null;

          return (
            <div
              key={index}
              className="calendar h-full w-1"
              style={{ backgroundColor: `#${color}` }}
            />
          );
        })}
        <div className="flex w-full justify-between items-center">
          <span
            className={classNames("ml-1 text-lg line-clamp-2 break-all", {
              "line-through": appointment.canceled,
            })}
          >
            {appointment.has_meeting && <FontAwesomeIcon icon={faComments} />}
            <a href={appointment.html_url}>{appointment.name}</a>
          </span>
          <div className="flex -m-5 ml-0">
            {appointment.meeting?.join_url && (
              <a
                className="btn flex btn-link btn-mobile items-center"
                href={appointment.meeting.join_url}
              >
                <FontAwesomeIcon icon={faDesktopCircleArrowRight} size="xl" />
              </a>
            )}
            {appointment.location?.link && (
              <a
                className="btn flex btn-link btn-mobile items-center"
                href={appointment.location.link}
              >
                <FontAwesomeIcon icon={faLocationDotArrow} size="xl" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
